import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Country from './MASTER/country'
import Currency from './MASTER/currency'
import Equipment from './GO/equipment'
import Vessel from './MASTER/vessel'
import Location from './MASTER/location'
import EquipmentType from './MASTER/equipmentType'
import EquipmentClass from './MASTER/equipmentClass'
import DangerousGoods from './MASTER/dangerousGoods'
import Incoterms from './MASTER/incoterms'
import VoyageList from './GO/Voyage/VoyageList'
import LogisticsType from './MASTER/logisticsType'
import Package from './MASTER/package'
import ShipmentTerms from './MASTER/shipmentTerms'
import Tax from './MASTER/Tax'
import { Company } from './MASTER/company'
import './pages.css'
import { LumpSum } from './MASTER/lumpSum'

export default function Master(props) {

  return (
    <>
      <div className='baseLineSubmenus'>
        <Routes>
          <Route path='country' element={<Country roles={props.roles} />} />
          <Route path='currency' element={<Currency roles={props.roles} />} />
          <Route path='equipment' element={<Equipment roles={props.roles} />} />
          <Route path='vessel' element={<Vessel roles={props.roles} tablesOrder={props.tablesOrder} onTablesOrderUpdate={props.onTablesOrderUpdate}/>} />
          <Route path='location' element={<Location roles={props.roles} />} />
          <Route path='equipmentType' element={<EquipmentType roles={props.roles} />} />
          <Route path='equipmentClass' element={<EquipmentClass roles={props.roles} />} />
          <Route path='dangerousGoods' element={<DangerousGoods roles={props.roles} />} />
          <Route path='voyage' element={<VoyageList roles={props.roles} />} />
          <Route path='incoterms' element={<Incoterms roles={props.roles} />} />
          <Route path='logisticsType' element={<LogisticsType roles={props.roles} />} />
          <Route path='package' element={<Package roles={props.roles} />} />
          <Route path='shipmentTerms' element={<ShipmentTerms roles={props.roles} />} />
          <Route path='tax' element={<Tax roles={props.roles} />} />
          <Route path='company' element={<Company onCreateTab={props.onCreateTab} roles={props.roles} toastMessages={props.toastMessages} tablesOrder={props.tablesOrder} onTablesOrderUpdate={props.onTablesOrderUpdate} />} />
          <Route path='lumpSumList' element={<LumpSum onCreateTab={props.onCreateTab} roles={props.roles} toastMessages={props.toastMessages} tablesOrder={props.tablesOrder} onTablesOrderUpdate={props.onTablesOrderUpdate} />} />
        </Routes>
      </div>
    </>
  )
}